export default {"src":"/_next/static/media/playbook-development.2d415c4e.svg","height":244,"width":304,"blurWidth":0,"blurHeight":0};